export class ResultsParser {
  #domParser;

  constructor({ dataAttribute, dataSelector, resultsSelector }) {
    this.#domParser = new DOMParser();
    this._dataAttribute = dataAttribute;
    this._dataSelector = dataSelector;
    this._resultsSelector = resultsSelector;
  }

  parseResults(html) {
    const doc = this.#domParser.parseFromString(html, 'text/html');

    const results = doc.querySelector(this._resultsSelector);

    const dataEl = doc.querySelector(this._dataSelector);
    const dataJsonString = dataEl?.getAttribute(this._dataAttribute) ?? '{}';
    const data = JSON.parse(dataJsonString);

    return { results, data };
  }
}
